/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Category from "./Category";
import GeoLocation from "../../components/GeoLocation/GeoLocation";
import { useSelector, useDispatch } from "react-redux";
import {
  changeView,
  buyPointNotification,
  addPointNotification,
} from "../../utils/action/Action";
import AddPointNotification from "../../components/Notification/AddPointNotification";
import BuyPointNotification from "../../components/Notification/BuyPointNotification";
import "./home.scss";
import NextPlaces from "../../components/NextPlaces";
import Header from "../../layout/Header";
// import hero_bg from "../../assets/hero_bg_image.png";
import BG from "../../assets/BG.svg";
import HomeTopPlaces from "../../components/TopPlaces/HomeTopPlaces";

const Home = ({
  pathName,
  userPoints,
  setUserPoints,
  isUserLoggedIn,
  userAuthentication,
}) => {
  const addPoint = useSelector(
    (state) => state?.addPointNotificationReducer?.notification
  );
  const buyPoint = useSelector(
    (state) => state.buyPointNotificationReducer?.notification
  );
  const location = GeoLocation();
  const dispatch = useDispatch();

  const [isAddPoint, setIsAddPoint] = useState(addPoint?.notification);
  const [isBuyPoint, setIsBuyPoint] = useState(buyPoint?.notification);

  useEffect(() => {
    dispatch(changeView("grid"));
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  const onDismiss = async () => {
    let obj = {
      notification: false,
    };
    dispatch(addPointNotification(obj));
    setIsAddPoint(false);
  };

  const onClose = async () => {
    let obj = {
      notification: false,
    };
    dispatch(buyPointNotification(obj));
    setIsBuyPoint(false);
  };

  return (
    <div className="main_section">
      {location?.loaded === true ? (
        <>
          {isAddPoint === true && (
            <AddPointNotification visible={isAddPoint} onDismiss={onDismiss} />
          )}
          {isBuyPoint === true && (
            <BuyPointNotification point={isBuyPoint} onClose={onClose} />
          )}
          <div
            style={{
              backgroundImage: `url(${BG})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Header
              pathName={pathName}
              userPoints={userPoints}
              setUserPoints={setUserPoints}
              isUserLoggedIn={isUserLoggedIn}
              userAuthentication={userAuthentication}
            />
            <HomeTopPlaces />
          </div>

          <Category />
          <NextPlaces />
        </>
      ) : (
        <>
          {isAddPoint === true && (
            <AddPointNotification visible={isAddPoint} onDismiss={onDismiss} />
          )}
          {isBuyPoint === true && (
            <BuyPointNotification point={isBuyPoint} onClose={onClose} />
          )}
          <div
            style={{
              backgroundImage: `url(${BG})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <Header
              pathName={pathName}
              userPoints={userPoints}
              setUserPoints={setUserPoints}
              isUserLoggedIn={isUserLoggedIn}
              userAuthentication={userAuthentication}
            />
            <HomeTopPlaces />
          </div>
          <Category />
          <NextPlaces />
        </>
      )}
    </div>
  );
};

export default Home;
